import { CameraMode } from "@hscmap/stellar-globe";
import { Store } from "@/store";
import { deepcopy } from "@/utils/deep";

let seq = 0

export function buildFrame(store: Store) {
  const view: IView = store.frames.length > 0 ? deepcopy(store.currentFrame.view) : defaultView()
  return {
    name: `Frame-${++seq}`,
    view,
    cameraMode: CameraMode.STEROGRAPHIC,
  }
}

function defaultView(): IView {
  return {
    a: 0,
    d: 0,
    fovy: 2,
    roll: 0,
  }
}

export interface IView {
  a: number
  d: number
  fovy: number
  roll: number
}
